export const formatDecimalOnBlur = (e) => {
  const { value } = e.target;

  if (!value) return;

  const number = parseFloat(value);

  if (!isNaN(number)) {
    e.target.value = number.toFixed(2);
  } else {
    e.target.value = '';
  }
};